import { render, staticRenderFns } from "./A11yPopover.vue?vue&type=template&id=788847ad"
import script from "./A11yPopover.vue?vue&type=script&lang=js"
export * from "./A11yPopover.vue?vue&type=script&lang=js"
import style0 from "./A11yPopover.vue?vue&type=style&index=0&id=788847ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports